/* This is the EMIS Staff Salary components */

<template>
  <v-container>
    <div>
      <span v-html="title"></span>
      <HelpIcon :help="htext"/>
    </div>
    <div>
      <table border="1px;" cellspacing="0px;">
        <tbody>
          <tr>
						<td style="width: 140px; height: 50px; text-align: center; vertical-align: middle;" rowspan="2">បុគ្គលិក</td>
						<td class="row-header" colspan="2">ចំនួនបុគ្គលិកបង្រៀន</td>
						<td class="row-header" colspan="2">ចំនួនបុគ្គលិកមិនបង្រៀន</td>
					</tr>
					<tr>
						<td class="row-data">សរុប</td>
						<td class="row-data">ស្រី</td>
						<td class="row-data">សរុប</td>
						<td class="row-data">ស្រី</td>
					</tr>
          <tr
            v-for="(value, row) in d5.length"
            :key="row"
            style="height: 25px; text-align: left"
          >
            <td style="width: 350px; height: 25px"><span v-html="d5[row]"></span></td>
            <td style="width: 60px; height: 25px">
              <numberinput v-model="data[row].dt[0]" style="width: 50px; text-align: center;" />
            </td>
            <td style="width: 60px; height: 25px">
              <numberinput v-model="data[row].dt[1]" style="width: 50px; text-align: center;" />
            </td>
            <td style="width: 60px; height: 25px">
              <numberinput v-model="data[row].dt[2]" style="width: 50px; text-align: center;" />
            </td>
            <td style="width: 60px; height: 25px">
              <numberinput v-model="data[row].dt[3]" style="width: 50px; text-align: center;" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import { d5 } from "@/utils/priascf/commonVariables.js";
import NumberInput from "@/components/common/NumberInput.vue";
export default {
  props: ["data", "title", "htext"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {
      d5: d5,
    };
  },
  computed: {
  },
};
</script>
<style scoped>
  .row-data {
    width: 40px;
    height: 25px;
    text-align: center;
    vertical-align: middle;
  }
  .row-header {
    width: 80px;
    height: 25px;
    text-align: center;
    vertical-align: middle;
  }
</style>